@for (spoersmaal of skjemakontroll().controls; track spoersmaal.value.spoersmaal!.id; let indeks=$index) {
  <spoerreundersoekelse-spoersmaal-skjema [skjemakontroll]="spoersmaal" [visValgtittel]="visValgtittel(indeks)" [valgtittelPlassering]="radioknappTittelplassering(indeks)"/>
}
